import React, { useEffect, useState } from 'react'

import "./styles.scss"
import Button from '../Button'
import ModalResource from '../ModalResource'
import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';
import Card from '../Card/Card'
import ModalItem from '../ModalItem'
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'
import Alert from '../Alert'
import ModalImportItems from '../ModalImportItems'
import CopyToClipboard from 'react-copy-to-clipboard'

export default function Resource({
    resource,
    setResourceOpened,
    getResource
}) {
    const [items, setItems] = useState([])
    const [isModalItemOpened, setIsModalItemOpened] = useState(null)
    const [isModalImportOpened, setIsModalImportOpened] = useState(null)

    const [alertOpened, setAlertOpened] = useState(false)
    const [alert, setAlert] = useState({})

    useEffect(() => {
        if (resource)
            start()
    }, [resource])

    const getItems = async () => {
        try {
            const result = await getResource(resource.key, "items")
            console.log(result)

            return resource?.type == "collection" ?
                (
                    Array.isArray(result.items) ?
                        result.items :
                        (result.items ? [result.items] : [])
                ) :
                result
        } catch (error) {
            if (typeof error == "string") {
                error = JSON.parse(error)
                if (error?.message && typeof error.message == "string")
                    error.message = JSON.parse(error.message)
            }

            console.log("error", error)

            if (error?.message?.reason?.code == 67)
                return resource?.type == "collection" ?
                    [] :
                    {}

            throw error
        }
    }

    const start = async () => {
        try {
            startLoading()
            let resources = await getItems()
            // console.log(resources)

            setItems(resources)
        } catch (error) {
            console.error(error)
        } finally {
            stopLoading()
        }
    }


    const remove = async (_id) => {
        try {
            startLoading()
            setAlertOpened(false)

            let items = []

            try {
                const result = await getResource(resource.key, "items")

                items = result?.items
            } catch (error) {
                if (typeof error == "string") {
                    error = JSON.parse(error)
                    if (error?.message && typeof error.message == "string")
                        error.message = JSON.parse(error.message)
                }

                console.log("error", error)

                if (error?.message?.reason?.code == 67) {
                    items = []
                } else
                    throw error
            }

            let newItems = items.filter(item => item._id != _id)

            const result = await IframeMessageProxy.sendMessage({
                action: IMPContainer.Actions.SEND_COMMAND,
                content: {
                    command: {
                        method: IMPContainer.CommandMethods.SET,
                        uri: `/resources/${resource.key}`,
                        type: "application/json",
                        resource: { items: newItems }
                    },
                    // destination: IMPContainer.Destinations.BLIP_SERVICE
                }
            });

            setItems(newItems)
        } catch (error) {
            // console.log(JSON.parse(error))
            // console.error(error)
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
            setAlertOpened(false)
        }
    }

    const download = (name, data) => {
        try {
            // create file in browser
            const fileName = `${name.split(" ").join("_")}`;
            const json = JSON.stringify(data, null, 2);
            const blob = new Blob([json], { type: "application/json" });
            const href = URL.createObjectURL(blob);

            // create "a" HTLM element with href to file
            const link = document.createElement("a");
            link.href = href;
            link.download = fileName + ".json";
            document.body.appendChild(link);
            link.click();

            // clean up "a" element & remove ObjectURL
            document.body.removeChild(link);
            URL.revokeObjectURL(href);
        } finally {
            setAlertOpened(false)
        }
    }

    const ShowData = ({
        field,
        data,
        empty = <></>
    }) =>
        <>
            {data == undefined ? empty :
                field.type == "object-list" ?
                    <bds-typo variant="fs-16"><i>{data.length} ite{data.length > 1 ? "ns" : "m"}</i></bds-typo> :
                    field.type == "switch" ?
                        <bds-typo variant="fs-16">{data ? "Sim" : "Não"}</bds-typo> :
                        field.type == "file" ?
                            <div className="typeFileTd" style={{ cursor: "pointer" }}>
                                <CopyToClipboard
                                    text={data}
                                    onCopy={() =>
                                        showToast({
                                            type: BlipPortalToastTypes.SUCCESS,
                                            title: "Copiado para a área de transferência!",
                                            message: "Link do arquivo copiado com sucesso."
                                        })
                                    }
                                >
                                    <bds-typo variant="fs-16">{data}</bds-typo>
                                </CopyToClipboard>
                            </div> :
                            field.type == "text-list" ?
                                <div>
                                    <ul style={{ margin: 0, padding: 0, paddingLeft: 15 }}>
                                        {data.map((text, index) =>
                                            <li key={index} style={{ marginLeft: 0, paddingLeft: 0, padding: 0 }}>
                                                <bds-typo variant="fs-16">{text}</bds-typo>
                                            </li>
                                        )}
                                    </ul>
                                </div> :
                                <bds-typo variant="fs-16">{data}</bds-typo>
            }
        </>

    return (
        <>
            <div className="items-list mt3 mb5">
                <div className="header mb3">
                    <div>
                        <h3>{resource?.name} {items.length > 0 ? `| ${items.length} ite${items.length > 1 ? "ns" : "m"}` : ""}</h3>
                    </div>

                    <div style={{ display: 'flex', gap: 10 }}>
                        <Button
                            text="Voltar"
                            variant="ghost"
                            arrow={false}
                            disabled={false}
                            onClick={() => setResourceOpened(null)}
                        />

                        {/* {resource?.type == "collection" && */}
                        <Button
                            text="Exportar"
                            variant="ghost"
                            arrow={false}
                            disabled={false}
                            onClick={() => {
                                setAlertOpened(() => true)
                                setAlert({
                                    header: "Atenção!",
                                    body: "O que você deseja exportar?",
                                    actions: [
                                        {
                                            variant: "secondary",
                                            bold: "true",
                                            title: "Cancelar",
                                            onClick: () => setAlertOpened(false)
                                        },
                                        {
                                            variant: "primary",
                                            bold: "true",
                                            title: "Itens e estrutura",
                                            onClick: async () => {
                                                download(resource.name, { items, resource })
                                            }
                                        },
                                        {
                                            variant: "primary",
                                            bold: "true",
                                            title: "Apenas a estrutura",
                                            onClick: async () => {
                                                download(resource.name, { resource })
                                            }
                                        },
                                        {
                                            variant: "primary",
                                            bold: "true",
                                            title: "Apenas os itens",
                                            onClick: async () => {
                                                download(resource.name, { items })
                                            }
                                        }
                                    ]
                                })
                            }}
                        />
                        {/* } */}

                        {resource?.type == "collection" &&
                            <Button
                                text="Importar Itens"
                                variant="ghost"
                                arrow={false}
                                disabled={false}
                                onClick={() => setIsModalImportOpened(true)}
                            />
                        }

                        {resource?.type == "collection" &&
                            <Button
                                text="Cadastrar Item"
                                variant="primary"
                                arrow={false}
                                disabled={false}
                                onClick={() => setIsModalItemOpened({})}
                            />
                        }
                    </div>
                </div>

                {resource?.type == "collection" &&
                    <>
                        {items.length == 0 ?
                            <div style={{ textAlign: "center" }}>
                                <bds-typo variant="fs-20" bold="light">Nenhum item cadastrado até o momento</bds-typo>
                            </div>
                            :
                            <div className="items">
                                <Card className="min-h-18">
                                    <table>
                                        <tbody>
                                            <tr>
                                                {resource.fields.map((field, index2) =>
                                                    <th key={index2} style={{ textAlign: "left" }}>
                                                        <bds-typo variant="fs-16" bold="bold">{field.label}</bds-typo>
                                                    </th>
                                                )}
                                                <th></th>
                                            </tr>
                                            {items.map((item, index) =>
                                                <tr key={index} className="card-resource">
                                                    {resource.fields.map((field, index2) =>
                                                        <td key={index2}>
                                                            <ShowData
                                                                field={field}
                                                                data={item[field.name]}
                                                            />

                                                            {/* {(index == 0 && index2 == 5) && <>{JSON.stringify(item)}</>} */}
                                                        </td>
                                                    )}
                                                    <td style={{ display: "flex", justifyContent: "flex-end" }}>
                                                        <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                            <div style={{ display: "flex", gap: 10 }}>
                                                                <div className="none">
                                                                    <CopyToClipboard
                                                                        text={item._id}
                                                                        onCopy={() =>
                                                                            showToast({
                                                                                type: BlipPortalToastTypes.SUCCESS,
                                                                                title: "Copiado para a área de transferência!",
                                                                                message: "O ID do item foi copiado com sucesso."
                                                                            })
                                                                        }
                                                                    >
                                                                        <Button
                                                                            variant="ghost"
                                                                            text={
                                                                                <div style={{ cursor: "pointer", margin: 0 }}>
                                                                                    <img src="/key.png" />
                                                                                </div>
                                                                            }
                                                                            arrow={false}
                                                                            disabled={false}
                                                                            onClick={() => { }}
                                                                        />
                                                                    </CopyToClipboard>
                                                                </div>
                                                                <div className="none">
                                                                    <Button
                                                                        variant="ghost"
                                                                        icon="trash"
                                                                        arrow={false}
                                                                        disabled={false}
                                                                        onClick={() => {
                                                                            setAlertOpened(() => true)
                                                                            setAlert({
                                                                                header: "Atenção!",
                                                                                body: "Tem certeza que deseja deletar este item? Você não conseguirá recuperá-lo depois.",
                                                                                actions: [
                                                                                    {
                                                                                        variant: "delete",
                                                                                        bold: "true",
                                                                                        title: "Cancelar",
                                                                                        onClick: () => setAlertOpened(false)
                                                                                    },
                                                                                    {
                                                                                        variant: "primary",
                                                                                        bold: "true",
                                                                                        title: "Sim, tenho certeza",
                                                                                        onClick: async () => {
                                                                                            remove(item._id)
                                                                                        }
                                                                                    }
                                                                                ]
                                                                            })
                                                                        }}
                                                                        size="short"
                                                                    />
                                                                </div>
                                                                <div className="none">
                                                                    <Button
                                                                        variant="ghost"
                                                                        icon="edit"
                                                                        arrow={false}
                                                                        disabled={false}
                                                                        onClick={() => setIsModalItemOpened(item)}
                                                                    />
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </tbody>
                                    </table>
                                </Card>
                            </div>
                        }
                    </>
                }

                {resource?.type == "single" &&
                    <div className="single">
                        <Card className="min-h-18">
                            <table>
                                <tbody>
                                    {resource?.fields?.map((field, index) =>
                                        <tr key={index} className="card-resource">
                                            <th style={{ textAlign: "left", paddingRight: 20 }}>{field.label}</th>
                                            {/* <td>{items?.[field.name] || }</td> */}
                                            <td>
                                                <ShowData
                                                    field={field}
                                                    data={items?.[field.name]}
                                                    empty={<i>Não informado</i>}
                                                />
                                            </td>

                                            <td style={{ display: "flex", justifyContent: "flex-end" }}>
                                                <div style={{ display: "flex", justifyContent: "space-between" }}>
                                                    <div style={{ display: "flex", gap: 10 }}>
                                                        <div className="none">
                                                            <Button
                                                                variant="ghost"
                                                                icon="edit"
                                                                arrow={false}
                                                                disabled={false}
                                                                onClick={() => setIsModalItemOpened({
                                                                    [field.name]: items?.[field.name] || null
                                                                })}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </Card>
                    </div>
                }

                <ModalItem
                    opened={isModalItemOpened}
                    setOpened={setIsModalItemOpened}
                    resource={resource}
                    getResource={getResource}
                    setItems={setItems}
                />

                <ModalImportItems
                    opened={isModalImportOpened}
                    setOpened={setIsModalImportOpened}
                    resource={resource}
                    getResource={getResource}
                    setItems={setItems}
                />
            </div>

            <Alert
                opened={alertOpened}
                setAlert={setAlert}
                {...alert}
            />
        </>
    )
}